export default "/images/c2d88e8b7a3e2504e45bdb0026237ded.avif";